<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-5"><a id="_idTextAnchor005"></a>You/Angel</h2>
<p class="Verse-new">So you were the angel</p>
<p class="Verse-main">who held me when I cried</p>
<p class="Verse-new">Nursed my grieving passion </p>
<p class="Verse-main">with your open-bodied grace</p>
<p class="Verse-new">Tears became the well-spring</p>
<p class="Verse-main">to salve my wounded life</p>
<p class="Verse-new">Yours the balm that healed me</p>
<p class="Verse-main">held me ’til I came back live</p>
<p class="Verse-new">Mourning turned to dancing </p>
<p class="Verse-main">my child farewelled in peace</p>
<p class="Verse-new">Your love will never leave me</p>
<p class="Verse-main">so long my beating heart.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-7.vue?55818477